module.exports = __webpack_public_path__ + "static/media/android-studio.ee1b9d89.svg";